import React, { useState, useEffect } from 'react'

import { Grid, Table, TableHead, TableBody, TableRow, TableCell, TextField, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Typography, Divider } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const template = {
  PAGE_ID: { 
    TOP_MULTI: { 
      DOM: '', 
      INTL: ''
    },
    DOM: '', 
    INTL: '' 
  },
  PLACEMENT_ID: { 
    TOP_MULTI: { 
      DOM: '', 
      INTL: ''
    },
    DOM: '', 
    INTL: ''
  }
}

export const Teads = ({ expandAllVendors, options, allOptions, setOptions, setAllOptions, errors, setErrors, validation }) => {
  const { PREBID } = options
  // console.log('Prebid: ', PREBID)
  const { VENDOR } = PREBID
  VENDOR.TEADS = {
    ...template,
    ...VENDOR.TEADS,
    PAGE_ID: {
      ...template.PAGE_ID,
      ...VENDOR.TEADS?.PAGE_ID,
      TOP_MULTI: {
        ...template.PAGE_ID.TOP_MULTI,
        ...VENDOR.TEADS?.PAGE_ID?.TOP_MULTI
      }
    },
    PLACEMENT_ID: {
      ...template.PLACEMENT_ID,
      ...VENDOR.TEADS?.PLACEMENT_ID,
      TOP_MULTI: {
        ...template.PLACEMENT_ID.TOP_MULTI,
        ...VENDOR.TEADS?.PLACEMENT_ID?.TOP_MULTI
      }
    }
  }
  const { TEADS } = VENDOR
  const { PAGE_ID, PLACEMENT_ID } = TEADS
  const { STRING } = validation
  const { LENGTH } = STRING
  const [expanded, setExpanded] = useState(expandAllVendors)

  useEffect(() => {
    setExpanded(expandAllVendors)
  }, [expandAllVendors])

  const displayPageIdTable = () => {
    return (
      <Table size='small' aria-label='teads-page-id-table'>
        <TableHead>
          <TableRow>
            <TableCell rowSpan={2}></TableCell>
            <TableCell align='center' colSpan={2}>Domestic</TableCell>
            <TableCell align='center' colSpan={2}>International</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align='center'>Top Multi</TableCell>
            <TableCell align='center'>Other</TableCell>
            <TableCell align='center'>Top Multi</TableCell>
            <TableCell align='center'>Other</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell style={{ width: '180px' }}><Typography variant='h6'>Page IDs</Typography></TableCell>
            <TableCell>
              <TextField
                margin='none'
                value={PAGE_ID.TOP_MULTI.DOM}
                error={errors.PREBID_TEADS_PIDD_TM}
                helperText={errors.PREBID_TEADS_PIDD_TM && LENGTH.message}
                onChange={(event) => {
                  const value = event.target.value
                  PREBID.VENDOR.TEADS.PAGE_ID.TOP_MULTI.DOM = value
                  setErrors({ ...errors, PREBID_TEADS_PIDD_TM: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options, PREBID })
                  setAllOptions({ ...allOptions, PREBID })
                }}
              />
            </TableCell>
            <TableCell>
              <TextField
                margin='none'
                value={PAGE_ID.DOM}
                error={errors.PREBID_TEADS_PIDD_OT}
                helperText={errors.PREBID_TEADS_PIDD_OT && LENGTH.message}
                onChange={(event) => {
                  const value = event.target.value
                  PREBID.VENDOR.TEADS.PAGE_ID.DOM = value
                  setErrors({ ...errors, PREBID_TEADS_PIDD_OT: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options, PREBID })
                  setAllOptions({ ...allOptions, PREBID })
                }}
              />
            </TableCell>
            <TableCell>
              <TextField
                margin='none'
                value={PAGE_ID.TOP_MULTI.INTL}
                error={errors.PREBID_TEADS_PIDI_TM}
                helperText={errors.PREBID_TEADS_PIDI_TM && LENGTH.message}
                onChange={(event) => {
                  const value = event.target.value
                  PREBID.VENDOR.TEADS.PAGE_ID.TOP_MULTI.INTL = value
                  setErrors({ ...errors, PREBID_TEADS_PIDI_TM: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options, PREBID })
                  setAllOptions({ ...allOptions, PREBID })
                }}
              />
            </TableCell>
            <TableCell>
              <TextField
                margin='none'
                value={PAGE_ID.INTL}
                error={errors.PREBID_TEADS_PIDI_OT}
                helperText={errors.PREBID_TEADS_PIDI_OT && LENGTH.message}
                onChange={(event) => {
                  const value = event.target.value
                  PREBID.VENDOR.TEADS.PAGE_ID.INTL = value
                  setErrors({ ...errors, PREBID_TEADS_PIDI_OT: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options, PREBID })
                  setAllOptions({ ...allOptions, PREBID })
                }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    )
  }

  const displayPlacementIdTable = () => {
    return (
      <Table size='small' aria-label='teads-placement-id-table'>
        <TableHead>
          <TableRow>
            <TableCell rowSpan={2} ></TableCell>
            <TableCell align='center' colSpan={2}>Domestic</TableCell>
            <TableCell align='center' colSpan={2}>International</TableCell>
          </TableRow>
          <TableRow>
            <TableCell align='center'>Top Multi</TableCell>
            <TableCell align='center'>Other</TableCell>
            <TableCell align='center'>Top Multi</TableCell>
            <TableCell align='center'>Other</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell style={{ width: '180px' }}><Typography variant='h6'>Placement IDs</Typography></TableCell>
            <TableCell>
              <TextField
                margin='none'
                value={PLACEMENT_ID.TOP_MULTI.DOM}
                error={errors.PREBID_TEADS_PLIDD_TM}
                helperText={errors.PREBID_TEADS_PLIDD_TM && LENGTH.message}
                onChange={(event) => {
                  const value = event.target.value
                  PREBID.VENDOR.TEADS.PLACEMENT_ID.TOP_MULTI.DOM = value
                  setErrors({ ...errors, PREBID_TEADS_PLIDD_TM: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options, PREBID })
                  setAllOptions({ ...allOptions, PREBID })
                }}
              />
            </TableCell>
            <TableCell>
              <TextField
                margin='none'
                value={PLACEMENT_ID.DOM}
                error={errors.PREBID_TEADS_PLIDD_OT}
                helperText={errors.PREBID_TEADS_PLIDD_OT && LENGTH.message}
                onChange={(event) => {
                  const value = event.target.value
                  PREBID.VENDOR.TEADS.PLACEMENT_ID.DOM = value
                  setErrors({ ...errors, PREBID_TEADS_PLIDD_OT: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options, PREBID })
                  setAllOptions({ ...allOptions, PREBID })
                }}
              />
            </TableCell>
            <TableCell>
              <TextField
                margin='none'
                value={PLACEMENT_ID.TOP_MULTI.INTL}
                error={errors.PREBID_TEADS_PLIDI_TM}
                helperText={errors.PREBID_TEADS_PLIDI_TM && LENGTH.message}
                onChange={(event) => {
                  const value = event.target.value
                  PREBID.VENDOR.TEADS.PLACEMENT_ID.TOP_MULTI.INTL = value
                  setErrors({ ...errors, PREBID_TEADS_PLIDI_TM: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options, PREBID })
                  setAllOptions({ ...allOptions, PREBID })
                }}
              />
            </TableCell>
            <TableCell>
              <TextField
                margin='none'
                value={PLACEMENT_ID.INTL}
                error={errors.PREBID_TEADS_PLIDI_OT}
                helperText={errors.PREBID_TEADS_PLIDI_OT && LENGTH.message}
                onChange={(event) => {
                  const value = event.target.value
                  PREBID.VENDOR.TEADS.PLACEMENT_ID.INTL = value
                  setErrors({ ...errors, PREBID_TEADS_PLIDI_OT: value.length < LENGTH.min || value.length > LENGTH.max })
                  setOptions({ ...options, PREBID })
                  setAllOptions({ ...allOptions, PREBID })
                }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    )
  }
  return (
    <ExpansionPanel expanded={expanded}>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls='teads-panel-content'
        id='teads-panel-header'
        onClick={() => setExpanded(!expanded)}
      >
        <Typography variant='h5'>Teads</Typography>
      </ExpansionPanelSummary>
      <Divider />
      <ExpansionPanelDetails>
        <Grid container spacing={2}>
          <Grid item xs={12}>{displayPageIdTable()}</Grid>
          <Grid item xs={12}>{displayPlacementIdTable()}</Grid>
        </Grid>
      </ExpansionPanelDetails>
    </ExpansionPanel>
  )
}
